/**
 * This file is a part of the Promvc framework.
 * 
 * (c) ThemePlexi
 * 
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import { ADD_ERROR, CLEAR_ERROR, CLEAR_ERRORS } from '../../constants/index.js';

/**
 * Settings errors reducer.
 * 
 * @param  {Array} state  The initial state.
 * @param  {String} action The action to perform. 
 * @return {Array}
 */
export default function ( state = [], action )
{
	switch( action.type )
	{
		case ADD_ERROR:
			return [ ...state, action.payload ];

		case CLEAR_ERROR:
			return state.filter( ( message, i ) => { return i !== action.payload; } );

		case CLEAR_ERRORS:
			return [];
		
		default:
			return [ ...state ];
	}
}